import React, { useEffect, useState } from 'react'
import { CustomButton, FilterBar, TableData } from '../../components'
import DownloadIcon from "@mui/icons-material/Download";
import { useDispatch } from 'react-redux';
import { downloadBinnacleReportService, getBinnacleReportService } from '../../services/report/reportService';
import { errorAlert } from '../../helpers/alerts';
import moment from 'moment';
import { downloadFile } from 'helpers/util';
import { setIcon, setTitle } from 'redux/slices/uiSlice';
import { Plagiarism } from '@mui/icons-material';
import { Box } from '@mui/material';

const BinnacleScreen = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [types, setTypes] = useState([])
  const [users, setUsers] = useState([])
  const [list, setList] = useState([])
  const [filters, setFilters] = useState({})
  const columns = [
    {
      name: "createdAt",
      label: "Fecha",
      format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss'),
      sort: ({ createdAt }) => createdAt,
    },
    {
      name: "event",
      label: "Tipo",
      format: ({ event }) => event,
      sort: ({ event }) => event,
    },
    {
      name: "description",
      label: "Descripcion",
      format: ({ description }) => description,
      sort: ({ description }) => description,
    },
    {
      name: "userName",
      label: "Usuario",
      format: ({ userName }) => userName,
      sort: ({ userName }) => userName,
    },
  ]
  useEffect(() => {
    dispatch(setTitle('Reporte de Bitacora'));
    dispatch(setIcon(<Plagiarism fontSize='large' htmlColor='#0E73ED' />));
  }, [])


  useEffect(() => {
    dispatch(setTitle('Reporte de bitacora'));
    setTypes(list
      .map(({ event: id, event: name }) => ({ id, name }))
      .filter(({ id }, index) => index === list.findIndex(o => id === o.event))
    );
    setUsers(list
      .map(({ userId: id, userName: name }) => ({ id, name }))
      .filter(({ id }, index) => index === list.findIndex(o => id === o.userId))
    );
  }, [list])

  const handlerSubmit = async (data) => {
    setFilters(data)
    setLoading(true)
    getBinnacleReportService(data).then((result) => setList(result))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const handlerDownload = () => {
    downloadBinnacleReportService([], filters)
      .then((data) => downloadFile(data, 'Reporte de Bitacora.xlsx'))
      .catch((e) => errorAlert(e))
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        defaultValues={{
          date: [new Date(), new Date()],
        }}
        allValue={null}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
          {
            name: 'type',
            label: "Tipo",
            type: "select",
            all: 'Todos',
            data: types,
          },
          {
            name: 'user',
            label: "Usuario",
            type: "select",
            all: 'Todos',
            data: users,
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loading}
          dataRows={list}
          sorteable={true}
          defaultOrderBy={"createdAt"}
          headerButtons={[
            <CustomButton
              dark={true}
              icon={<DownloadIcon />}
              key="download"
              name={"Descargar"}
              click={handlerDownload}
            />,
          ]}
          sorteableData={data => data.map(item => {
            columns.map(({ name, format, sort }) => item[`_${name}_`] = sort ? sort(item) : format(item))
            return item
          })}
          dataTitle={columns}
          formatter={({ userName, event, createdAt, description }) => ([
            moment(createdAt).format('DD/MM/YYYY HH:mm:ss'),
            event,
            description,
            userName,
          ])}
        />
      </Box>
    </>

  )
}

export default BinnacleScreen